import { PossibleOccupancy, RoomType } from '../types'

export const validateRoomConfiguration = (
	adults: number,
	children: number[],
	roomTypes: RoomType[]
): boolean => {
	if (!roomTypes || roomTypes.length === 0) return false

	const childrenAges = children || []

	// Iterate through room types to find any valid configuration
	return roomTypes.some((roomType: RoomType) =>
		roomType.possibleOccupancies.some((occupancy: PossibleOccupancy) => {
			if (occupancy.adults !== adults || occupancy.children !== childrenAges.length) {
				return false
			}

			if (childrenAges.length === 0) return true

			let remainingChildren = [...childrenAges]
			let remainingCategories = [...occupancy.childrenAgeCategories]

			while (remainingChildren.length > 0 && remainingCategories.length > 0) {
				const childAge = remainingChildren[0]
				let foundMatch = false

				for (let catIndex = 0; catIndex < remainingCategories.length; catIndex++) {
					const category = remainingCategories[catIndex]
					if (childAge >= category.minAge && childAge <= category.maxAge) {
						remainingChildren = remainingChildren.slice(1)
						remainingCategories = [
							...remainingCategories.slice(0, catIndex),
							...remainingCategories.slice(catIndex + 1),
						]
						foundMatch = true
						break
					}
				}

				if (!foundMatch) break
			}

			return remainingChildren.length === 0 && remainingCategories.length === 0
		})
	)
}
